import {components} from 'react-select';

export const Option = (props) => {
  const {innerProps, label} = props;

  return <components.Option {...props} innerProps={{...innerProps, 'data-qa-id': label}} />;
};
